import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';

export default function DateDisplay() {
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date: Date): string => {
    const days = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
    const months = [
      'ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני',
      'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'
    ];

    const dayName = days[date.getDay()];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `יום ${dayName}, ${day} ב${month} ${year}`;
  };

  return (
    <div className="flex items-center justify-center gap-2 bg-gray-700 bg-opacity-50 rounded-lg px-4 py-3 shadow-md">
      <Calendar size={20} className="text-blue-400" />
      <span className="text-sm font-medium text-gray-200">
        {formatDate(currentDate)}
      </span>
    </div>
  );
}
